import request from '@/utils/request'


/**
 * 仿真实训详情页面根据id查单独课程
 * @returns 
 */
export function getdetailList(params) {
  return request({
    url: '/simulation/simulation_lib/getdetaillist',
    method: 'GET',
    params,
  })
}

/**
 * 仿真实训详情页面根据id查单独课程
 * @returns 
 */
export function queryCourseThree(params) {
  return request({
    url: '/simulation/simulation_lib/queryCourseThree',
    method: 'GET',
    params,
  })
}

/**
 * 查询任务
 * @param {Object} params 
 * @returns 
 */
export function listSimulation(params) {
  return request({
    url: '/simulation/simulation_lib/list',
    method: 'GET',
    params,
  })
}

/**
 * 查询审核列表
 * @param {Object} params 
 * @returns 
 */
export function listAduitSimulation(params) {
  return request({
    url: '/simulation/simulation_lib/aduit_list',
    method: 'GET',
    params,
  })
}

/**
 * 查询审核列表
 * @param {Object} params 
 * @returns 
 */
export function listSimulationByCourse(params) {
  return request({
    url: '/simulation/simulation_lib/listByCourseId',
    method: 'GET',
    params,
  })
}



export function updateSort(data) {
  return request({
    url: '/simulation/simulation_lib/updateSort',
    method: 'POST',
    data,
  })
}

/**
 * 查询单个任务
 * @param {Object} params 
 * @returns 
 */
export function getSimulationInfo(_id) {
  return request({
    url: '/simulation/simulation_lib/findOne',
    method: 'GET',
    params: {
      _id,
    },
  })
}

/**
 * 添加任务
 * @param {Object} data 
 * @returns 
 */
export function addSimulation(data) {
  return request({
    url: '/simulation/simulation_lib/insert',
    method: 'POST',
    data,
  })
}

/**
 * 重新提交
 * @param {Object} data 
 * @returns 
 */
export function resetSimulation(data) {
  return request({
    url: '/simulation/simulation_lib/resetSimulation',
    method: 'POST',
    data,
  })
}


/**
 * 修改任务
 * @param {Object} data 
 * @returns 
 */
export function updateSimulation(data) {
  return request({
    url: '/simulation/simulation_lib/update',
    method: 'POST',
    data,
  })
}

/**
 * 版本检查
 * @param {*} data 
 * @returns 
 */
export function checkSimalationVersion(data) {
  return request({
    url: '/simulation/simulation_lib/checkVersion',
    method: 'POST',
    data,
  })
}


/**
 * 删除
 * @param {Object} data 
 * @returns 
 */
export function removeSimulation(data) {
  return request({
    url: '/simulation/simulation_lib/remove',
    method: 'POST',
    data,
  })
}


/**
 * 添加任务
 * @param {Object} data 
 * @returns 
 */
export function getSimulationById(data) {
  return request({
    url: '/simulation/simulation_lib/getById',
    method: 'get',
    data,
  })
}



//添加模型资源库收藏
export function setcollect(data) {
  return request({
    url: '/simulation/simulation_lib/setcollect',
    method: 'POST',
    data,
  })
}



/**
 * 修改任务
 * @param {Object} data 
 * @returns 
 */
export function getCourseLeft(data) {
  return request({
    url: '/simulation/simulation_lib/courseleft',
    method: 'POST',
    data,
  })
}

/**
 * 添加课程评论
 * @param {Object} data 
 * @returns 
 */
export function addMessage(data) {
  return request({
    url: '/simulation/simulation_lib/addMessage',
    method: 'POST',
    data,
  })
}
/**
 * 查询话题讨论
 * @param {Object} data 
 * @returns 
 */
export function queryMessage(params) {
  return request({
    url: '/simulation/simulation_lib/queryMessage',
    method: 'GET',
    params,
  })
}



//根据用户id去获取用户信息

/**
 * 查询话题讨论
 * @param {Object} data 
 * @returns 
 */
export function getbyIdQueryUser(params) {
  return request({
    url: '/simulation/simulation_lib/getbyIdQueryUser',
    method: 'GET',
    params,
  })
}

/**
 *  结算预览次数
 * @param {Object} data 
 * @returns 
 */
export function sendTime(data) {
  return request({
    url: '/simulation/simulation_lib/sendTime',
    method: 'POST',
    data,
  })
}

/**
 * 查询启动参数
 * @param {Object} data 
 * @returns 
 */
export function simulationParams(data) {
  return request({
    url: '/simulation/params',
    method: 'POST',
    data,
  })
}


